import script from "./Activity_Goodkid2026demo0612.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity_Goodkid2026demo0612.vue?vue&type=script&setup=true&lang=js"

import "./Activity_Goodkid2026demo0612.vue?vue&type=style&index=0&id=4f509dde&lang=less&scoped=true"
import "./Activity_Goodkid2026demo0612.vue?vue&type=style&index=1&id=4f509dde&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f509dde"]])

export default __exports__